import { StoreDto } from '@dto';
import { StoreStatusEnum } from '@models';

export const getSiteBessStatus = (stores: StoreDto[]): StoreStatusEnum => {
  if (!stores?.length) {
    return null;
  }
  let lowerStatuses = stores.map(store => store.status?.toLowerCase());
  lowerStatuses = lowerStatuses.filter(l => l);
  if (lowerStatuses.includes('hobbled')) {
    return StoreStatusEnum.HOBBLED;
  }
  if (lowerStatuses.includes('alarm')) {
    return StoreStatusEnum.ALARM;
  }
  if (lowerStatuses.every(status => status === 'charging' || status === 'generating')) {
    return StoreStatusEnum.RUNNING;
  }
  return StoreStatusEnum.UNAVAILABLE;
};
